/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as BannerVariants } from './banner-variants.story';
export { default as BannerCloseable } from './banner-closeable.story';
export { default as BannerGlobal } from './banner-global.story';
export { default as BannerWithActions } from './banner-with-actions.story';
export { default as BannerWithIcons } from './banner-with-icons.story';
export { default as BannerWithoutTitle } from './banner-without-title.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import BannerCloseableSrcRaw from './banner-closeable.story?raw';
import BannerGlobalSrcRaw from './banner-global.story?raw';
import BannerVariantsSrcRaw from './banner-variants.story?raw';
import BannerWithActionsSrcRaw from './banner-with-actions.story?raw';
import BannerWithIconsSrcRaw from './banner-with-icons.story?raw';
import BannerWithoutTitleSrcRaw from './banner-without-title.story?raw';

export const BannerVariantsSrc = removeLicenseHeader(BannerVariantsSrcRaw);

export const BannerCloseableSrc = removeLicenseHeader(BannerCloseableSrcRaw);

export const BannerGlobalSrc = removeLicenseHeader(BannerGlobalSrcRaw);

export const BannerWithActionsSrc = removeLicenseHeader(
  BannerWithActionsSrcRaw,
);

export const BannerWithIconsSrc = removeLicenseHeader(BannerWithIconsSrcRaw);

export const BannerWithoutTitleSrc = removeLicenseHeader(
  BannerWithoutTitleSrcRaw,
);
